import styled from '@emotion/styled';
import { colors } from '@smartsheet/lodestar-core';

export const Container = styled.div<{ isLoading: boolean }>`
  background: ${colors.dangerDark30};
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props =>
    props.isLoading ? colors.neutralLight40 : colors.leftNavBackground};
`;
